<!-- 群星官网 -->
<template>
  <div v-if="$route.path.indexOf('/openLogin') === 0">
    <router-view></router-view>
  </div>
  <div
    id="viewPort"
    v-else
  >
    <Header :onLogin="showLoginModal" />
    <transition name="fade">
      <router-view :onLogin="showLoginModal"></router-view>
    </transition>
    <modal-login ref="loginModal" />
    <update-modal />
  </div>
</template>

<script>
import baseVueOptions from '@/assets/js/BaseVueOptions'
import Header from './Header'
import UpdateModal from '@/components/UpdateModal'
import { ismobile } from '@/assets/js/CommonUtils'
import 'babel-polyfill'
// import WX from './../js/jweixin-1.0.0.js'

// function initWechat (vm) {
//   const nonceStr = 'abcdefg'
//   const timestamp = new Date().getTime().toString().substring(0, 10)
//   const locationUrl = location.origin + location.pathname + location.search
//   const shareLogo = 'https://www.iqunxing.com/imgs/portal/home/wechart-logo.jpg'

//   vm.ajax({
//     url: '/services/public/mobile/getSignature',
//     type: 'POST',
//     data: {
//       nonceStr: nonceStr,
//       timestamp: timestamp,
//       url: locationUrl
//     },
//     success: function (resp) {
//       WX.config({
//         debug: false,
//         appId: 'wx5b8b94317c7511eb',
//         timestamp: timestamp,
//         nonceStr: nonceStr,
//         signature: resp.body.result.signature,
//         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
//       })
//     }
//   })

//   WX.ready(function () {
//     WX.onMenuShareTimeline({
//       title: '群星金融',
//       desc: '群星金融-让企业平等获得金融服务',
//       link: locationUrl,
//       imgUrl: shareLogo
//     })

//     WX.onMenuShareAppMessage({
//       title: '群星金融',
//       desc: '群星金融-让企业平等获得金融服务',
//       link: locationUrl,
//       imgUrl: shareLogo
//     })
//   })
// }

function getPageNavBarSettings (path) {
  const settings = {}
  settings.navTitle = document.title
  if (path) {
    if (path.indexOf('/industrySolution') !== -1) {
      settings.target = 'by-industry'
    } else if (path.indexOf('/role') !== -1) {
      settings.target = 'by-role'
    } else if (path.indexOf('/productSolution') !== -1) {
      settings.target = 'by-product'
    } else {
      settings.target = ''
    }
  }

  return settings
}

const subMenu = {
  role: {
    classification: '按角色查看',
    subTitle: [{
      title: '核心企业',
      link: '/role/core'
    }, {
      title: '供应商',
      link: '/role/supplier'
    }, {
      title: '经销商',
      link: '/role/dealer'
    }, {
      title: '资金方',
      link: '/role/fund'
    }]
  },
  product: {
    classification: '按产品查看',
    subTitleClass: 'product',
    subTitle: [{
      title: '虚拟财务公司',
      link: '/productSolution/virtualFinanceCompany'
    }, {
      title: '供应商应收账款融资(N+1)',
      link: '/productSolution/supplier'
    }, {
      title: '核心企业应收账款卖断(1+N)',
      link: '/productSolution/core'
    }, {
      title: 'DPP(动态提前付款)',
      link: '/productSolution/investment'
    }, {
      title: '星金券',
      link: '/productSolution/bond'
    }]
  },
  industrySolution: {
    classification: '按行业查看',
    subTitle: [{
      title: '零售行业',
      link: '/industrySolution/retail'
    }, {
      title: '医药流通行业',
      link: '/industrySolution/medicine'
    }, {
      title: '汽配行业',
      link: '/industrySolution/auto'
    }, {
      title: 'IT分销行业',
      link: '/industrySolution/it'
    }, {
      title: '服饰行业',
      link: '/industrySolution/dress'
    }, {
      title: '物流行业',
      link: '/industrySolution/logistics'
    }, {
      title: '制造行业',
      link: '/industrySolution/manufacture'
    }]
  }
}

export default {
  extends: baseVueOptions,
  components: {
    Header,
    'modal-login': function (resolve) {
      require(['./ModalLogin'], resolve)
    },
    'update-modal': UpdateModal
  },
  data () {
    return {
      registerUrl: location.hash === '#/role/fund' ? '/minisites/registration_org/' : '/minisites/registration/',
      subMenuPath: '',
      subMenuShowPath: '',
      currentUrl: '',
      menus: [
        {
          label: '首页',
          link: '/'
        },
        {
          label: '产品及解决方案',
          link: 'javascript:',
          class: '/solutions',
          subMenu: subMenu
        },
        {
          label: '关于群星',
          link: '/about'
        },
        {
          label: '企业动态',
          link: '/news'
        },
        {
          label: '联系我们',
          link: '/contact'
        },
        {
          label: '群星app',
          link: '/download'
        }
      ]
    }
  },
  created () {
    // 提供给外部使用的登录，不需要初始化
    if (this.$route.path.indexOf('/openLogin') === 0) {
      return
    }
    let ua = navigator.userAgent.toLowerCase()
    if (ua.includes('iphone') || ua.includes('android')) {
      location.href = 'mobile.html'
    }
    const pageNavBarSettings = getPageNavBarSettings()
    this.navTitle = pageNavBarSettings.navTitle
    this.currentUrl = location.hash
    this.updateMenuState(location.hash)
    // initWechat(this)
  },
  watch: {
    '$route' (to, from) {
      const pageNavBarSettings = getPageNavBarSettings(to.path)
      const currentUrl = location.hash
      this.currentUrl = currentUrl
      this.updateMenuState(currentUrl)
      if (to.matched.length > 0) {
        this.navTitle = pageNavBarSettings.navTitle
        this.updateSubMenuPath(pageNavBarSettings.target)
        window.scrollTo(0, 0)
      } else {
        location.href = '/#/'
      }
    }
  },
  methods: {
    updateMenuState (currentUrl) {
      // 路由寻址 匹配侧边栏状态
      if ((currentUrl.indexOf('/industrySolution/') > -1) || currentUrl.indexOf('/role/') > -1 || currentUrl.indexOf('/productSolution/') > -1) {
        this.menus[1].class = 'router-link-active'
        if (currentUrl.indexOf('/industrySolution/') > -1) {
          this.subMenuPath = 'by-industry'
          this.subMenuShowPath = 'by-industry'
        } else if (currentUrl.indexOf('/role/') > -1) {
          this.subMenuPath = 'by-role'
          this.subMenuShowPath = 'by-role'
        } else if (currentUrl.indexOf('/productSolution/') > -1) {
          this.subMenuPath = 'by-product'
          this.subMenuShowPath = 'by-product'
        }
      } else {
        this.menus[1].class = ''
        this.subMenuPath = ''
      }
    },
    showLoginModal (param) {
      if (ismobile()) {
        if (param === 'org') {
          location.href = '/m/org.html'
        } else {
          this.$router.push({
            path: '/download'
          })
        }
      } else {
        this.$refs.loginModal.open(param)
      }
    },
    openQQ () {
      window.open('http://wpa.b.qq.com/cgi/wpa.php?ln=2&uin=800002432',
        '_blank',
        'height=502, width=644,toolbar=no,scrollbars=no,menubar=no,status=no')
    },
    updateSubMenuPath (target) {
      // 更新用户点击操作状态
      const vm = this
      if (target === 'back') {
        if (vm.subMenuPath === 'by-classification') {
          vm.subMenuPath = ''
          vm.subMenuShowPath = ''
        } else {
          vm.subMenuPath = 'by-classification'
          setTimeout(function () {
            vm.subMenuShowPath = 'by-classification'
          }, 300)
        }
      } else {
        vm.subMenuPath = target
        vm.subMenuShowPath = target
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/utils";
@import "~@/assets/css/mobile";
@import "~@/assets/css/transition";
@import "../css/theme-config";
@import "../css/theme";
$defaultFontColor: #2c3e50;
$pageColor: #e6e6e6;
html {
  @include htmlBase();
}

body {
  @include bodyBase($pageColor, $defaultFontColor);
  @include mobileBodyBase();
}

#updateBrow {
  color: #717071;
  text-align: center;
  font-size: 14px;

  .modal-dialog {
    width: 647px;
    margin-top: 85px;
  }

  .modal-header,
  .modal-body {
    border-bottom: none;
    padding: 0;
  }
  .modal-header:after,
  .modal-footer:after {
    clear: both;
    content: "";
    display: block;
  }
  p,
  h4 {
    color: #717071;
    margin: 0;
  }

  h4 {
    font-size: 0.16rem;
  }

  #chrome {
    width: 0.5rem;
    height: 0.5rem;
    background-image: url(/imgs/portal/home/google_icon.png);
    margin: 0.24rem auto 0.1rem;

    @include media2x(url(/imgs/portal/home/google_icon@2x.png));
  }

  #download {
    width: 2.2rem;
    background-color: #4876cd;
    border: none;
    color: #fff;
    height: 0.45rem;
    display: block;
    margin: 0.1rem auto;
    border-radius: 6px;
    line-height: 0.45rem;
  }

  .advantage {
    margin: 0.1rem;
    display: inline-block;
    margin-top: 0.24rem;
  }

  .suggest {
    color: #aaa;
    font-size: 0.12rem;
    position: relative;
  }

  .warn {
    width: 0.12rem;
    height: 0.12rem;
    display: block;
    position: absolute;
    left: -0.16rem;
    top: 3px;
    background-color: #aaa;
    color: #fff;
    line-height: 0.12rem;
    border-radius: 0.06rem;
  }

  .modal-footer {
    margin-top: 0.3rem;
    background-color: #e1e7ed;
    text-align: center;
    padding: 0.2rem 1rem;
  }

  .disadvantage {
    float: left;
    font-size: 0.12rem;
    width: 1.2rem;

    p {
      font-size: 0.16rem;
    }

    #safe {
      width: 0.35rem;
      height: 0.4rem;
      margin: 0.1rem auto;
      background-image: url(/imgs/portal/home/safe_icon.png);

      @include media2x(url(/imgs/portal/home/safe_icon@2x.png));
    }

    #pc {
      width: 0.4rem;
      height: 0.4rem;
      margin: 0.1rem auto;
      background-image: url(/imgs/portal/home/pc_icon.png);

      @include media2x(url(/imgs/portal/home/pc_icon@2x.png));
    }

    #match {
      width: 0.38rem;
      height: 0.4rem;
      margin: 0.1rem auto;
      background-image: url(/imgs/portal/home/match_icon.png);

      @include media2x(url(/imgs/portal/home/match_icon@2x.png));
    }
  }
}

#viewPort {
  background-color: $Color5;
  min-width: 9.3rem;
  @include mediaQuery() {
    min-width: 100%;
    width: 100%;
  }
}

#navMenuBar {
  height: 0.5rem;
  position: relative;

  .inner {
    background-color: #000;
    left: 0;
    min-width: 9.3rem;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 500;
    @include mediaQuery() {
      min-width: 100%;
    }
  }

  .logo:after {
    @include icon();
    content: $ICO-LOGO;
    display: block;
    float: left;
    font-size: 0.4rem;
    height: 0.5rem;
    line-height: 0.5rem;
    margin-left: 0.1rem;
    position: static;
    text-align: center;
    width: 1.4rem;
  }

  .menu-list {
    li {
      float: left;
      height: 0.5rem;
      line-height: 0.5rem;
      padding: 0;
      text-align: center;
      margin: auto 0.05rem;

      &:hover {
        a {
          color: #ccc;
          background-color: rgba(6, 6, 6, 0.15);
        }

        .sub-menu {
          display: block;
          @include mediaQuery() {
            display: none;
          }
        }
      }

      &:nth-child(2) {
        width: 1.2rem;
        @include mediaQuery() {
          width: 7rem;
        }
        &:hover {
          a {
            background-color: #fff;
            color: #000;
            @include mediaQuery() {
              background-color: transparent;
              color: #fff;
            }
          }
        }
      }

      a {
        color: #fff;
        display: block;
        height: 0.5rem;
        font-size: 0.14rem;
        padding: 0 0.05rem;
        font-weight: bold;
        @include mediaQuery() {
          font-size: 0.2rem;
          padding: 0 0.2rem;
        }

        &.solutions {
          cursor: default;
        }
      }

      .sub-menu {
        display: none;
      }

      .sub-menu-solutions {
        background-color: #fff;
        height: 2.2rem;
        position: relative;
        width: 4.8rem;

        .col {
          cursor: default;
          float: left;
          width: 24%;

          &:nth-child(2) {
            width: 50%;
          }

          .section {
            border-bottom: 1px solid #333;
            font-weight: 700;
            height: 0.3rem;
            line-height: 0.3rem;
            margin: 0.1rem;
            text-align: left;
          }

          .product {
            li {
              list-style-type: disc;
              text-indent: -0.14rem;
              margin-left: 0.23rem;
              text-align: left;
              width: 90%;
              &:first-child {
                text-indent: 0;
                list-style: none;
                margin-left: 0;
              }
            }
          }

          li {
            height: 0.2rem;
            line-height: 0.2rem;
            padding: 0.01rem 0.05rem;
            text-align: left;
            width: 100%;
            font-size: 0.12rem;
            &.router-link-active a {
              color: #4876cd;
            }

            a {
              color: #333;
              height: 0.2rem;
              line-height: 0.2rem;
              font-weight: 100;
              &:hover {
                color: #4876cd;
              }
            }
          }
        }
      }
    }
  }

  .menu-contact {
    color: #fff;
    height: 0.5rem;
    display: block;
    float: left;

    .qq {
      @include mediaQuerySmall() {
        line-height: 0.2rem;
        height: 0.3rem;
      }
      a:after {
        @include icon();
        content: $ICO-QQ;
        position: relative;
        @include mediaQuery() {
          font-size: 0.3rem;
        }
        @include mediaQuerySmall() {
          font-size: 0.24rem;
        }
      }

      &:hover {
        .tooltip {
          display: block;
        }
      }
    }
    .phone {
      text-align: center;
      a:after {
        @include icon();
        content: $ICO-PHONE;
        position: relative;
        @include mediaQuery() {
          font-size: 0.3rem;
        }
        @include mediaQuerySmall() {
          font-size: 0.24rem;
        }
      }
    }

    .QR {
      a:after {
        @include icon();
        content: $ICO-QR;
        position: relative;
        @include mediaQuery() {
          font-size: 0.3rem;
        }
      }
    }

    li {
      width: 0.4rem;
      display: inline-block;
      line-height: 0.32rem;
      cursor: pointer;
      height: 0.5rem;
      position: relative;
      text-align: center;
      vertical-align: top;
      @include mediaQuery() {
        width: 30%;
      }

      &.QR {
        .tip {
          width: 1.52rem;
        }
      }

      &.phone {
        .tip {
          width: 2.44rem;
        }
      }

      .tooltip {
        background-color: #333;
        color: #fff;
        position: absolute;
        width: 75px;
        font-size: 0.12rem;
        font-weight: bold;
        top: 50px;
        display: none;

        &:after {
          content: "";
          position: absolute;
          bottom: 100%;
          left: 0.12rem;
          width: 0;
          height: 0;
          border-width: 6px;
          border-style: solid;
          border-color: transparent;
          border-bottom-width: 9px;
          border-bottom-color: #333;
        }
      }

      .tip {
        background: #fff;
        color: #000;
        display: none;
        position: absolute;

        .QR-download {
          background-image: url(/imgs/portal/home/app_download_QR.png);
          color: #fff;
          position: relative;
          margin: 0.1rem auto;
          width: 1.3rem;
          height: 0.8rem;
          background-size: cover;
          @include media2x(url(/imgs/portal/home/app_download_QR@2x.png));
        }
      }

      a {
        width: 100%;
        height: 100%;
        display: block;
        line-height: 0.5rem;
        text-align: center;
        @include mediaQuery() {
          font-size: 0.48rem;
        }

        &:hover {
          color: #ccc;
        }
      }

      &:not(:first-child):hover {
        background-color: #fff;
        @include mediaQuery() {
          background-color: transparent;
        }

        .tip {
          display: block;
          @include mediaQuery() {
            display: none;
          }
        }

        a {
          color: #ccc !important;
        }

        .sub-menu {
          display: block;
        }
      }

      &.qq:hover {
        a:after {
          color: #ccc;
        }
      }

      &.phone:hover,
      &.QR:hover {
        a:after {
          color: #000;
          @include mediaQuery() {
            color: #fff;
          }
        }
      }
    }
  }

  .menu-login {
    display: block;
    float: right;
    height: 0.5rem;
    margin-right: 0.1rem;

    li {
      float: left;
      margin-top: 0.15rem;

      &:nth-child(1) {
        a {
          border: 1px solid #fff;
          border-radius: 0.1rem;
        }
      }

      a {
        border: 1px solid transparent;
        color: #fff;
        display: block;
        font-size: 0.12rem;
        padding: 0.02rem;
        text-align: center;
        width: 0.7rem;
        &:hover {
          color: #ccc;
        }
      }
    }
  }

  #productSolutionMobileMenu,
  .back {
    display: none;
  }

  @include mediaQuery() {
    #slide-menu {
      &:after {
        @include icon();
        content: $ICO-MENU;
        position: relative;
      }
    }

    .slidable-section {
      background: linear-gradient(to right bottom, #ae00ff, #005bab);
      color: #fff;

      .menu-list {
        padding-top: 19%;
        text-align: center;

        li {
          width: 100%;
          text-align: left;
          height: auto;
          transition: transform 0.3s ease-in-out;
          margin: 0;
        }
      }

      .menu-contact {
        bottom: 1.5rem;
        position: absolute;
        text-align: center;
        width: 100%;
      }

      .menu-login {
        bottom: 1rem;
        margin: 0;
        position: absolute;
        text-align: center;
        width: 100%;

        li {
          box-sizing: border-box;
          float: none;
          margin: 0.15rem auto;
          width: 80%;

          a {
            border: 1px solid #fff;
            border-radius: 0.25rem;
            width: 100%;
            font-size: 0.2rem;
            padding: 0.1rem 0;
          }
        }
      }

      .sub-menu-root {
        height: 0.5rem;
        left: 0;
        position: absolute;
        transform: translateY(0.5rem);
        width: 100%;
        z-index: 42;
      }

      .back {
        display: block;
        left: 0.1rem;
        position: absolute;
        top: 0.1rem;
        z-index: 42;
        &:before {
          @include icon();
          content: $ICO-PREV;
          position: relative;
          display: none;
          font-size: 0.2rem;
          padding: 0.1rem;
        }
      }

      #productSolutionMobileMenu {
        display: block;
        left: 100%;
        position: absolute;
        transition: all 0.3s ease-in-out;
        width: 200%;
        z-index: 41;

        .level1,
        .level2 {
          float: left;
          transition: transform 0.3s ease-in-out;
          width: 50%;
        }

        .level-menu {
          color: #fff;
          font-size: 0.2rem;
          padding: 0.1rem 0.2rem;

          &.router-link-active {
            background-color: rgba(6, 6, 6, 0.15);

            a {
              color: #fff;
              font-weight: bold;
            }
          }

          &.active {
            background-color: rgba(6, 6, 6, 0.15);
            color: #fff;
            font-weight: bold;
          }

          a {
            color: #fff;
          }
        }

        ul {
          &.by-industry,
          &.by-role,
          &.by-product {
            display: none;
            &.show {
              display: block;
            }
          }
        }
      }
    }

    &.by-classification {
      #productSolutionMobileMenu {
        left: 0;
      }

      .back:before {
        display: block;
      }

      .menu-list {
        li {
          transform: translate(-100%, 0);
        }
      }

      .sub-menu-root {
        display: none;
      }
    }

    &.by-industry,
    &.by-role,
    &.by-product {
      #productSolutionMobileMenu {
        left: 0;
        .level1,
        .level2 {
          transform: translate(-100%, 0);
        }
      }

      .back:before {
        display: block;
      }

      .menu-list {
        li {
          transform: translate(-100%, 0);
        }
      }

      .sub-menu-root {
        display: none;
      }
    }
  }
  @include mediaQuerySmall() {
    .inner .slidable-section {
      .menu-list {
        height: auto;
        li {
          line-height: 0.4rem;
          a {
            font-size: 0.2rem;
            height: auto;
          }
        }
      }
      .menu-contact {
        height: auto;
        float: none;
        bottom: 1.1rem;
        li {
          float: none;
          height: 0.3rem;
          vertical-align: top;
          a {
            line-height: 0.3rem;
            font-size: 0.3rem;
          }
        }
      }
      .menu-login {
        height: auto;
        bottom: 0;
        li {
          display: block;
          margin: 0.1rem auto;
          a {
            padding: 0.05rem 0;
            line-height: 0.28rem;
          }
        }
      }
      .sub-menu-root {
        top: 0.8rem;
        height: 0.4rem;
        transform: translateY(0);
      }
    }

    #productSolutionMobileMenu .level2 {
      .level-menu {
        padding: 0.07rem 0.2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Portal.vue?2da84852